import React, { useCallback, useState } from 'react';
import { useLocation } from 'react-router-dom'

import FullOffertInfoModal from 'components/FullOffertInfoModal/FullOffertInfoModal'
import { AppLinks } from 'enviroment/AppLinks'
import { FULL_OFFERT_MENU_TYPES, IFullOffertInfoMenuProps } from './FullOffertInfoMenuProps'

import PaykaWalletIcon from 'assets/icons/wallet-icon.svg'
import PaykaInfoIcon from 'assets/icons/payka-information-icon.svg'
import RetentionTooltip from 'assets/retention-tooltip.svg'
import useIsMobile from 'common/hooks/useIsMobile'
import { WorkflowTypes } from 'common/workflow'

import './FullOffertInfoMenuStyles.scss'

const FullOffertInfoMenu = (props: IFullOffertInfoMenuProps) => {
   const [isOpen, setIsOpen] = useState(false)
   const handleOnMenuClose = useCallback(() => setIsOpen(false), [])
   const isMobileDevice = useIsMobile()

   const currentPathName = useLocation().pathname
   const pagesWithoutWalletMenu = [AppLinks.productPage, AppLinks.error, AppLinks.success, AppLinks.cancel, AppLinks.fail, AppLinks.sessionEnd, AppLinks.houston]

   const getMenuIconToUse = () => {
      switch(props.menuType){
         case FULL_OFFERT_MENU_TYPES.WALLET: {
            return PaykaWalletIcon
         }
         case FULL_OFFERT_MENU_TYPES.INFO: {
            return PaykaInfoIcon
         }
      }
   }

   const handleOnWalletIconClick = () => {
      if(props.menuType === FULL_OFFERT_MENU_TYPES.INFO) {
         if(props.isLoading === true) { // Używane w okienku z kalendarzem rat. Gdy modal przelicza ofertę (jest w stanie ładowania), nie chcemy pokazywać szczegółów nieprzeliczonej oferty.
            return
         }

         setIsOpen(true)
      }
      else if (props.menuType === FULL_OFFERT_MENU_TYPES.WALLET) {

         // USTALENIE BIZNESOWE- ikona portfela ma być klikalna tylko na mobilnym ekranie z retencją
         if(isMobileDevice && currentPathName === AppLinks.retention){
            setIsOpen(true)
         }
         else {
            return
         }
      }
   }

   if(props.isNavbarWalletMenu && pagesWithoutWalletMenu.includes(currentPathName)) {
      return null
   }
   else {
      return (
         <span className='full-offert-info-menu-wrapper'>
            <img onClick={handleOnWalletIconClick}  src={getMenuIconToUse()} alt='wallet' className={props.className ?? ''} />
            {(isMobileDevice && currentPathName === AppLinks.retention) && <img src={RetentionTooltip} alt='Twoja płatność' className='retention-tooltip-placeholder' /> } {/* Tooltip pojawiający się tylko na ekranie retencji.  */}
            <FullOffertInfoModal isOpen={isOpen} handleOnClose={handleOnMenuClose} />
         </span>
      ) 
   }
}

export default FullOffertInfoMenu
